import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=787a780c&"
import script from "./Stories.vue?vue&type=script&lang=js&"
export * from "./Stories.vue?vue&type=script&lang=js&"
import style0 from "./Stories.vue?vue&type=style&index=0&id=787a780c&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports